import { DashboardPage, createDashboardLayout } from "../components/DashboardPage/DashboardPage.jsx";
import { BudgetGridSection } from "../features/budget/BudgetGridSection.jsx";
import { BudgetSidebar } from "../features/budget/BudgetSidebar.jsx";

const budgetPageLayout = createDashboardLayout({
  columns: [
    { size: "fill" },
    { size: "fixed", value: "17rem" }
  ],
  rows: [
    { size: "fill" }
  ],
  areas: [
    ["grid", "summary"]
  ]
});

export function BudgetPage({
  page,
  dateContext,
  budgetDraftEntryRequest,
  onNavigateToPage,
  onRowsChange,
  onLoadSampleData,
  onImportPreviousYearBudget,
  onStartBudgetEntry,
  hasPreviousYearBudgetRows = false,
  detailMode,
  onDetailModeChange,
  showAltHints = false,
  t = (key) => key
}) {
  return (
    <DashboardPage
      layout={budgetPageLayout}
      slots={[
        {
          key: "grid",
          area: "grid",
          content: (
            <BudgetGridSection
              page={page}
              onNavigateToPage={onNavigateToPage}
              onRowsChange={onRowsChange}
              budgetDraftEntryRequest={budgetDraftEntryRequest}
              onLoadSampleData={onLoadSampleData}
              onImportPreviousYearBudget={onImportPreviousYearBudget}
              onStartBudgetEntry={onStartBudgetEntry}
              hasPreviousYearBudgetRows={hasPreviousYearBudgetRows}
              detailMode={detailMode}
              onDetailModeChange={onDetailModeChange}
              showAltHints={showAltHints}
              t={t}
            />
          )
        },
        {
          key: "summary",
          area: "summary",
          content: <BudgetSidebar rows={page.rows} expenseRows={page.expenseRows} dateContext={dateContext} t={t} />
        }
      ]}
    />
  );
}
